export const classNameRoot = 'dopt-checklist' as const;
